module.exports = __webpack_public_path__ + "media/images/flags/pt-4082bfb9ef5259e8b67780c59d219201.svg";